import Chords from './Chords';

const Progressions = {
  C: {
    name: 'C',
    type: 'scale',
    color: 'text-blue-600',
    chordOrder: ['C', 'G', 'Am', 'F'],
    tempo: 60
  }
  ,D: {
    name: 'D',
    type: 'scale',
    color: 'text-cyan-600',
    chordOrder: ['D', 'A', 'Bm', 'G'],
    tempo: 60
  }
  ,E: {
    name: 'E',
    type: 'scale',
    color: 'text-gray-600',
    chordOrder: ['E', 'B', 'CHm', 'A'],
    tempo: 60
  }
  ,F: {
    name: 'F',
    type: 'scale',
    color: 'text-red-600',
    chordOrder: ['F', 'C', 'Dm', 'Bb'],
    tempo: 60
  }
  ,G: {
    name: 'G',
    type: 'scale',
    color: 'text-purple-600',
    chordOrder: ['G', 'D', 'Em', 'C'],
    tempo: 60
  }
  ,A: {
    name: 'A',
    type: 'scale',
    color: 'text-green-600',
    chordOrder: ['A', 'E', 'FHm', 'D'],
    tempo: 60
  }
  ,B: {
    name: 'B',
    type: 'scale',
    color: 'text-pink-600',
    chordOrder: ['B', 'FH', 'GHm', 'E'],
    tempo: 60
  }
  ,JonasFacil: {
    name: 'Jonas facil (D)',
    type: 'song',
    coverUrl: 'jonas',
    chordOrder: ['D', 'D', 'G', 'G'],
    tempo: 130
  }
  ,Jonas: {
    name: 'Jonas (D)',
    type: 'song',
    coverUrl: 'jonas',
    chordOrder: ['D', 'Bm', 'G', 'G'],
    tempo: 130
  }
  ,SoyFeliz: {
    name: 'Soy feliz (C)',
    type: 'song',
    coverUrl: 'soy feliz',
    chordOrder: ['F', 'C', 'G', 'Am'],
    tempo: 130
  }
  ,ObrandoEnMi: {
    name: 'Obrando en mi (F)',
    type: 'song',
    coverUrl: 'obrando en mi',
    chordOrder: ['Dm', 'Bb', 'F', 'C'],
    tempo: 63
  }
  ,SiempreQueMeMuevo: {
    name: 'Siempre que me muevo (E)',
    type: 'song',
    coverUrl: 'nana',
    chordOrder: ['E', 'A', 'B', 'A'],
    tempo: 97
  }
  ,Ejercicio1BbDm: {
    name: 'Ejercicio 1: Dm Bb',
    type: 'exercise',
    chordOrder: ['Dm', 'Bb'],
    tempo: 60
  }
  ,Ejercicio2BbF: {
    name: 'Ejercicio 2: Bb F',
    type: 'exercise',
    chordOrder: ['Bb', 'F'],
    tempo: 60
  }
  ,Ejercicio3FC: {
    name: 'Ejercicio 3: F C',
    type: 'exercise',
    chordOrder: ['F', 'C'],
    tempo: 60
  }
  ,Ejercicio4CDm: {
    name: 'Ejercicio 4: C Dm',
    type: 'exercise',
    chordOrder: ['C', 'Dm'],
    tempo: 60
  }
  ,Ejercicio5DG: {
    name: 'Ejercicio 5: D G',
    type: 'exercise',
    chordOrder: ['D', 'G'],
    tempo: 60
  }
  ,Ejercicio6DBm: {
    name: 'Ejercicio 6: D Bm',
    type: 'exercise',
    chordOrder: ['D', 'Bm'],
    tempo: 60
  }
  ,Ejercicio7BmG: {
    name: 'Ejercicio 7: Bm G',
    type: 'exercise',
    chordOrder: ['Bm', 'G'],
    tempo: 60
  }
  ,Ejercicio8EA: {
    name: 'Ejercicio 8: E A',
    type: 'exercise',
    chordOrder: ['E', 'A'],
    tempo: 60
  }
  ,Ejercicio9BA: {
    name: 'Ejercicio 9: B A',
    type: 'exercise',
    chordOrder: ['B', 'A'],
    tempo: 60
  }
  ,ElGuerreroDavid1: {
    name: 'El guerrero David 1 (C)',
    type: 'song',
    coverUrl: 'david',
    chordOrder: ['C', 'G', 'Am', 'F'],
    tempo: 130
  }
  ,TeDoyGloria: {
    name: 'Te doy gloria (C)',
    type: 'song',
    coverUrl: 'te doy gloria',
    chordOrder: ['C', 'G', 'Am', 'F'],
    tempo: 136
  }
  ,EresIncreible: {
    name: 'Eres Increible (C)',
    type: 'song',
    coverUrl: 'eres increible',
    chordOrder: ['F', 'C', 'G', 'Am'],
    tempo: 130
  }
  ,YaYa: {
    name: 'Ya Ya (C)',
    type: 'song',
    coverUrl: 'ya ya',
    chordOrder: ['C','C', 'Am','Am', 'G','G', 'F','F'],
    tempo: 188
  }
};

export default Progressions;